import React from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { expression } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { FooterAPI } from './footer-api.js';
import './footer.css';
function Footer(props) {
    if (!props.visible) {
        return null;
    }
    return (React.createElement("div", { className: "c-footer" },
        React.createElement("span", { className: "c-footer__text" }, MessageService.translate(props.textExpression))));
}
Footer.propTypes = {
    textExpression: expression,
};
Footer.defaultProps = {
    textExpression: 'tws.footer.text',
    visible: true,
};
const awesomeProps = {
    api: FooterAPI,
    type: ComponentType.LAYOUT,
};
AwesomeComponent(awesomeProps)(Footer);
export { Footer, };
//# sourceMappingURL=footer.js.map